function locationSearchButtonClick(inputId) {
    if(jQuery('.locationModule[data-id='+inputId+'] .search-location').val() != '') {
        jQuery('.locationModule[data-id='+inputId+'] .error-msg').hide();
        let input = document.getElementById("acResultsList").firstChild;
        let mouseEventClick = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
        });
        input.dispatchEvent(mouseEventClick);
    } else {
        jQuery('.locationModule[data-id='+inputId+'] .error-msg').show();
    }
}

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function checkCookiePermissions() {
    return getCookie('seb_geolocation', '') ?? '';
}

function checkUserAgent() {
    // facebook and instagram block location so don't attempt geolocation
    let ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || (ua.indexOf('Instagram') > -1);
}

function checkLocationPermissions() {
    if (checkCookiePermissions() != 'blocked' && !checkUserAgent()) {
        if ( navigator.permissions && navigator.permissions.query) {
            const permissionStatus = navigator.permissions.query({name: 'geolocation'});
            if (permissionStatus.state !== 'denied') {
                return true;
            } else {
                setCookie('seb_geolocation', 'blocked');
                return false;
            }
        } else if (navigator.geolocation) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function googleAutocompleteWidget() {
    jQuery(document).ready(function ($) {
        let $locationSearchField = $('#locationFinderInput, #searchField'),
            $locationSearchForm = $("#locationFinder, #locationFinderCampaign, #workoutFinder");
        $locationSearchField.attr('autocomplete','off');

        if ($locationSearchField.length > 0) {
            let searchQuery, latLngExist, latQuery, lngQuery, geoPopup = true;
            if ($('#locationFinder.no-geo-popup, #locationFinderCampaign.no-geo-popup').length > 0) {geoPopup = false;}
            if ($('#locationFinder.find-location-widget').length > 0) { // location module on home page
                $('#locationFinder.find-location-widget').submit(function (event) {
                    event.preventDefault();
                    if ($("#acResultsList").length && $locationSearchField.val().indexOf(',') == -1) {
                        searchQuery = $('body').find("#acResultsList div.result-item.first-child").data('prediction');
                        $locationSearchField.val(searchQuery);
                    } else {
                        searchQuery = $locationSearchField.val();
                    }
                    latLngExist = document.getElementById("locationFinderLat");
                    if (latLngExist) {
                        latQuery = jQuery('#locationFinderLat').val();
                        lngQuery = jQuery('#locationFinderLng').val();
                    }
                    if ((latLngExist && latQuery.length > 0 && lngQuery.length > 0) || searchQuery.length > 0) {
                        let setUrl = dynamicURLs.locationFinderPage;
                        if (typeof(dynamicURLs.locationFinderPage) === 'undefined') {
                            setUrl = dynamicURLs.findGymPage;
                        }
                        if (setUrl[setUrl.length - 1] != '/') {
                            setUrl = setUrl + '/';
                        }
                        if (latLngExist && latQuery.length > 0 && lngQuery.length > 0) {
                            // Set cookie values
                            setCookie('location_lat', latQuery, 0.0007); // expires after about 1 minute
                            setCookie('location_lng', lngQuery, 0.0007);
                            setCookie('location_search', encodeURIComponent(searchQuery), 0.0007);
                        } else if (searchQuery.length > 0) {
                            setCookie('location_search', encodeURIComponent(searchQuery), 0.0007);
                        }
                        window.location.href = setUrl;
                        jQuery('#locationFinder').find('.ajax-loader').addClass('active');
                        jQuery('#locationFinder').find('.fa-search').hide();
                    }
                });
            }

            let displaySuggestions = function (predictions, status) {
                let currResultCount = -1,
                    resultField = jQuery(":focus").parent().find('.results-count');
                if (resultField.data('count') !== undefined) {
                    currResultCount = resultField.data('count');
                }
                if (status != google.maps.places.PlacesServiceStatus.OK) {
                    if (status === 'ZERO_RESULTS') {
                        if (currResultCount != 0) {
                            currResultCount = 0;
                            resultField.text(currResultCount + ' ' + translations.a11y.autocomplete_results_found_plural).data('count','0');
                        }
                    } else {
                        console.log(status);
                    }
                    return;
                }
                let resultDIV = document.createElement('ul'),
                    searchFieldOffset = jQuery(":focus").offset(),
                    searchFieldHeight = jQuery(":focus").outerHeight(),
                    searchFieldWidth = jQuery(":focus").outerWidth(),
                    resultOffset = searchFieldOffset.top + searchFieldHeight;
                if (jQuery("body").hasClass('home') && jQuery("#location-finder-search").length && jQuery("#locationFinder").hasClass('old')) {
                    searchFieldWidth = searchFieldWidth + 14;
                }
                resultDIV.setAttribute('id', 'acResultsList');
                resultDIV.setAttribute('role', 'listbox');
                resultDIV.setAttribute('aria-labelledby', 'label');
                resultDIV.setAttribute('style', 'top:'+resultOffset+'px;left:'+searchFieldOffset.left+'px;width:'+searchFieldWidth+'px;');
                $('body').append(resultDIV);
                $("#locationFinderInput").attr('aria-expanded',true);
                if (currResultCount != predictions.length) {
                    currResultCount = predictions.length;
                    if (currResultCount == '1') {
                        resultField.text(currResultCount + ' ' + translations.a11y.autocomplete_results_found_singular).data('count',currResultCount);
                    } else {
                        resultField.text(currResultCount + ' ' + translations.a11y.autocomplete_results_found_plural).data('count',currResultCount);
                    }
                }

                predictions.forEach(function (prediction, i, array) {
                    let resultLI = document.createElement('li'),
                        predictionDesc = prediction.structured_formatting.main_text,
                        predictionMatch = predictionDesc.substring(prediction.structured_formatting.main_text_matched_substrings[0].offset, prediction.structured_formatting.main_text_matched_substrings[0].length),
                        predictionReplace = '<span class="match-location">' + predictionDesc.replace(predictionMatch, '<span class="match-bold">' + predictionMatch + "</span>") + '</span>';
                    if (prediction.structured_formatting.secondary_text != undefined) {
                        predictionReplace += '<span class="match-context">' + prediction.structured_formatting.secondary_text + '</span>';
                    }
                    resultLI.innerHTML = predictionReplace;
                    resultLI.setAttribute('data-origin-element', $(document.activeElement)[0].form.id);
                    resultLI.setAttribute('data-prediction', prediction.description);
                    resultLI.setAttribute('data-placeid', prediction.place_id);
                    resultLI.setAttribute('id', 'acResultsList-option-'+i);
                    resultLI.setAttribute('role', 'option');
                    resultLI.setAttribute('tabindex', '-1');
                    $(resultLI).addClass('result-item');
                    if (i == 0) {
                        $(resultLI).addClass('first-child');
                    } else if (i == array.length - 1) {
                        $(resultLI).addClass('last-child');
                    }
                    $('#acResultsList').append(resultLI);
                });
            };

            let map_autocomplete_options = {
                    types: ['geocode']
                },
                map_autocomplete_latlng;
            if(mapGlobalOptions.restrict_by_site_country_code == true) {
                $.extend(map_autocomplete_options, {componentRestrictions: { country: mapGlobalOptions.site_country_code }});
            }
            if (mapGlobalOptions.location_bias_center.lat && mapGlobalOptions.location_bias_center.lng) {
                map_autocomplete_latlng = new google.maps.LatLng(mapGlobalOptions.location_bias_center.lat, mapGlobalOptions.location_bias_center.lng);
            }
            let seb_geolocation = checkCookiePermissions();
            if (seb_geolocation) {
                if (seb_geolocation != 'blocked') {
                    let seb_coords  = seb_geolocation.split(',');
                    map_autocomplete_latlng = new google.maps.LatLng(parseFloat(seb_coords[0]), parseFloat(seb_coords[1]));
                }
            } else if (geoPopup) {
                if (checkLocationPermissions()) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        map_autocomplete_latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        setCookie('seb_geolocation', position.coords.latitude+','+position.coords.longitude);
                    },function(){
                        setCookie('seb_geolocation', 'blocked');
                    });
                } else {
                    console.log("Geolocation is blocked or not supported by this browser.");
                }
            }
            if (map_autocomplete_latlng != undefined) {
                $.extend(map_autocomplete_options,
                    {location: map_autocomplete_latlng, radius: parseFloat(mapGlobalOptions.location_bias_radius), origin: map_autocomplete_latlng});
            }
            let service = new google.maps.places.AutocompleteService();
            $locationSearchField.on('input', debounce(function () {
                $('#acResultsList').remove();
                $("#locationFinderInput").attr('aria-activedescendant','').attr('aria-expanded',false);
                $('.error-msg').hide();
                let acValue = this.value;
                if (acValue.length > 2) {
                    $.extend(map_autocomplete_options, {input: acValue});
                    service.getPlacePredictions(map_autocomplete_options, displaySuggestions);
                }
            }, 300));

            $locationSearchField.on('keydown', function (event) {
                let isFirstResult = true, $resultsSelection = $("#acResultsList li.result-item[aria-selected='true']");
                if ($resultsSelection.length > 0) {
                    isFirstResult = false;
                }
                const key = event.key; // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
                let focusNext = false, focusPrev = false;
                switch (key) {
                    case "Escape":
                        $('#acResultsList').remove();
                        break;
                    case "ArrowDown":
                        focusNext = true;
                        break;
                    case "ArrowUp":
                        focusPrev = true;
                        break;
                    case "Tab":
                        if ($("#acResultsList").length && !event.shiftKey) {
                            if ($("#acResultsList").css( "display" ) == 'none') {
                                $locationSearchField.next().focus();
                            } else {
                                focusNext = true;
                            }
                        }
                        break;
                    case "Enter":
                        event.preventDefault();
                        if ($("#acResultsList").length) {
                            $(this).attr('aria-activedescendant',$resultsSelection.prop('id'));
                            updateSearchField($resultsSelection);
                        } else {
                            updateSearchField($(this),0);
                        }
                        break;
                    default:
                        break;
                }
                if (focusNext) {
                    event.preventDefault();
                    if (!isFirstResult) {
                        $resultsSelection.attr('aria-selected',false).next().attr('aria-selected',true);
                        $(this).attr('aria-activedescendant', $resultsSelection.next().prop('id'));
                    } else {
                        $("#acResultsList li.result-item").first().attr('aria-selected',true);
                        $(this).attr('aria-activedescendant', $("#acResultsList li.result-item").first().prop('id'));
                    }
                    return false;
                } else if (focusPrev) {
                    event.preventDefault();
                    if (!isFirstResult) {
                        $resultsSelection.attr('aria-selected',false).prev().attr('aria-selected',true);
                        $(this).attr('aria-activedescendant', $resultsSelection.prev().prop('id'));
                    } else {
                        $("#acResultsList li.result-item").last().attr('aria-selected',true);
                        $(this).attr('aria-activedescendant', $("#acResultsList li.result-item").last().prop('id'));
                    }
                    return false;
                }
            });

            function updateSearchField(element,prediction = 1) {
                let originElement = $("#"+$(element).data('originElement'));
                originElement.find('.ajax-loader').addClass('active');
                originElement.find('.fa-search').hide();
                $('#acResultsList').hide();
                $("#locationFinderInput").attr('aria-activedescendant','').attr('aria-expanded',false);
                let searchPlaceId = $(element).data('placeid');
                if (prediction) {
                    let searchQuery = $(element).data('prediction');
                    originElement.find('[data-location-finder-input]').val(searchQuery);
                }
                if (searchPlaceId && originElement.hasClass('find-location-widget')) { // Geocode if it's location module
                    let searchGeocoder = new google.maps.Geocoder;
                    searchGeocoder.geocode({'placeId': searchPlaceId}, function (results, status) {
                        if (status !== 'OK') {
                            console.log('Geocoder failed due to: ' + status);
                            return;
                        }

                        originElement.find("#locationFinderLat").val(results[0].geometry.location.lat());
                        originElement.find("#locationFinderLng").val(results[0].geometry.location.lng());
                        originElement.submit(); // call within geocoder so submit doesn't occur before lat/lng are found
                    });
                } else {
                    originElement.find("#locationFinderLat, #locationFinderLng").val("");
                    originElement.submit();
                }
            }

            $(document).click(function(event) {
                let $target = $(event.target);
                if(!$target.closest('#acResultsList').length &&
                    $('#acResultsList').is(":visible")) {
                    $('#acResultsList').remove();
                }
            });
            $('body').on('click', '#acResultsList li.result-item', function () {
                updateSearchField(this);
            });
            $('body').on('keydown', '#acResultsList li.result-item', function (event) {
                const key = event.key; // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
                let focusNext = false, focusPrev = false,
                    currentFocus = $('body').find("#acResultsList li.result-item[aria-selected='true']"),
                    currentInput = $('body').find("#locationFinderInput[aria-activedescendant='"+currentFocus.attr('id')+"']");
                switch (key) {
                    case "ArrowDown":
                        focusNext = true;
                        break;
                    case "ArrowUp":
                        focusPrev = true;
                        break;
                    case "Tab":
                        if (event.shiftKey) {
                            focusPrev = true;
                        } else if (!currentFocus.hasClass('last-child')) {
                            focusNext = true;
                        } else if (currentFocus.hasClass('last-child')) {
                            $locationSearchField.next().focus();
                        }
                        break;
                    case "Enter":
                        event.preventDefault();
                        // Up pressed
                        updateSearchField(this);
                        break;
                    default:
                        break;
                }
                if (focusNext) {
                    event.preventDefault();
                    if (currentFocus.hasClass('last-child')) {
                        currentFocus.attr('aria-selected',false);
                    } else {
                        currentFocus.attr('aria-selected',false).next().attr('aria-selected',true);
                    }
                    currentInput.attr('aria-activedescendant', currentFocus.prop('id'));
                    return false;
                } else if (focusPrev) {
                    event.preventDefault();
                    if (currentFocus.hasClass('first-child')) {
                        currentFocus.attr('aria-selected',false);
                    } else {
                        currentFocus.attr('aria-selected',false).prev().attr('aria-selected',true);
                    }
                    currentInput.attr('aria-activedescendant', currentFocus.prop('id'));
                    return false;
                }
            });
        }
    });
}

function googleIsReady() {
    googleAutocompleteWidget();
}
